import React, { type PropsWithChildren } from 'react';
import ForecastHeader from 'components/ForecastHeader';
import { PageTypes } from 'components/ForecastHeader/hooks/usePageDetails';
import { getSubregionOverviewData } from 'selectors/subregion';
import { useAppSelector } from 'stores/hooks';
import { getSpotDetails, getSpotReportForecast } from 'selectors/spot';

const SpotChartsPageContainer: React.FC<PropsWithChildren> = ({ children }) => {
  const spot = useAppSelector(getSpotDetails);
  const spotReportForecastData = useAppSelector(getSpotReportForecast);
  const subregionOverview = useAppSelector(getSubregionOverviewData);

  return (
    <div className="sl-subregion-forecast-page">
      <div>
        <section className="sl-section-container">
          <ForecastHeader
            conditions={spotReportForecastData?.conditions?.value}
            hasLiveCam={spot?.cameras?.length > 0}
            pageTitle={spot?.name ? `${spot?.name} Surf Report` : 'Surf Charts'}
            pageType={PageTypes.SPOT_CHARTS}
            spot={spot}
            subregionOverview={subregionOverview}
          />
        </section>
        {children}
      </div>
    </div>
  );
};

export default SpotChartsPageContainer;
